<div class="form-input">
  @if (label) {
    <label [for]="idHTML">
      {{ label | transloco }}
      @if (isRequired) {
        <span>*</span>
      }
    </label>
  }
  <mat-form-field appearance="outline">
    <mat-select
      [formControl]="_control"
      [id]="idHTML"
      [multiple]="multiple()"
      [panelClass]="panelClass()">
      @if (multiple()) {
        <mat-select-trigger>
          @if (_control.value.length === selectionOptions().length) {
            {{ 'forms.allOptions' | transloco }}
          } @else {
            {{ selectedOptions() | translateJoin }}
          }
        </mat-select-trigger>
      }

      @if (!multiple()) {
        <mat-select-trigger>
          @for (option of selectionOptions(); track option) {
            @if (option.value === _control.value) {
              @if (option.icon) {
                <div class="option-content">
                  <img
                    [src]="'../../../../../../assets/svg/' + option.icon + '.svg'"
                    alt=""
                    class="option-icon" />
                  <span>{{ option.label ? (option.label | transloco) : option.value }}</span>
                </div>
              } @else {
                {{ option.label ? (option.label | transloco) : option.value }}
              }
            }
          }
        </mat-select-trigger>
      }

      @for (option of selectionOptions(); track option) {
        <mat-option (onSelectionChange)="onOptionClicked($event)" [value]="option.value">
          @if (!option.icon) {
            <span>
              {{ option.label ? (option.label | transloco) : option.value }}
            </span>
          }
          @if (option.icon) {
            <div class="option-content">
              <img
                [src]="'../../../../../../assets/svg/' + option.icon + '.svg'"
                alt=""
                class="option-icon" />
              <span>{{ option.label ? (option.label | transloco) : option.value }}</span>
            </div>
          }
        </mat-option>
      }
    </mat-select>
    @if (_control.invalid) {
      <mat-error>
        {{ errorMessage | transloco: errorParams }}
      </mat-error>
    }
  </mat-form-field>
</div>
